var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('zf-widget',{staticClass:"cost-container",attrs:{"allowDeviceSelection":true},on:{"device-selected":function($event){_vm.selectedDeviceId = $event}}},[_c('current-month',{attrs:{"dataType":_vm.CurrentMonthDataType.CONSUMPTION,"selectedDeviceId":_vm.selectedDeviceId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }